module.exports = __webpack_public_path__ + "img/icn_brand14_black.8a2319c3.svg";